<template>
    <div id="admin_channel_groupings_page" class="container-fluid">
        <h4 class="margin-left10">Client: {{ client.name }}</h4>

        <v-client-table :data="tableData" :columns="columns" :options="options">
            <div slot="new_name" slot-scope="props">
                <v-select placeholder="Select Grouping" :selectable="option => props.row.original_name !== option.original_name" :value="props.row.new_name" @input="changeGrouping(props.row, $event)" label="original_name" :options="dropdown_data"></v-select>
            </div>

            <div slot="status" slot-scope="props">
                <span v-if="props.row.new_name">Changed</span>
            </div>
        </v-client-table>

        <div class="text-center margin-top20">
            <button @click="$router.go(-1)" type="button" class="btn btn-info">Back</button>
            <button
                v-if="tableData.length > 0"
                id="save_groupings"
                :disabled="save_disabled"
                data-loading-text='<span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>Saving...'
                @click="saveGroupings"
                type="button"
                class="btn btn-success"
            >SAVE</button>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        data() {
            return {
                client: {},
                new_grouping_names: {},
                original_data: {},
                save_disabled: true,
                columns: ['original_name', 'new_name', 'status'],
                tableData: [],
                dropdown_data: [],
                options: {
                    headings: {
                        original_name: 'Analytics Channel Grouping',
                        new_name:      'Re-assigned Channel Grouping',
                        status:        'Status'
                    },
                    sortable: ['original_name'],

                    perPage: 1000,
                    perPageValues: [],
                    texts: {
                        count: '',
                        filter: '',
                        filterPlaceholder: '',
                        noResults: 'No matching groupings'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get(`/api/clients/${this.$route.params.id}`),
                    axios.get(`/api/admin/channel-groupings?client_id=${this.$route.params.id}`)
                ])
                .then(axios.spread((client, channelGroupings) => {
                    this.client    = client.data;
                    this.tableData = channelGroupings.data;

                    this.dropdown_data = vm.customClone(channelGroupings.data);
                    this.dropdown_data.push({
                        original_name: 'Hide'
                    });

                    _.each(channelGroupings.data, value => {
                        this.original_data[value.id]      = value.new_name;
                        this.new_grouping_names[value.id] = value.new_name;
                    });
                }));
            },

            changeGrouping(originalData, newData) {
                const index = _.findIndex(this.tableData, {id: originalData.id});

                if (index > -1) {
                    this.tableData[index].new_name           = newData ? newData.original_name : null;
                    this.new_grouping_names[originalData.id] = newData ? newData.original_name : null;
                }

                this.validate();
            },

            saveGroupings() {
                $('#save_groupings').button('loading');

                axios.put('/api/admin/channel-groupings', {groupings: JSON.stringify(this.new_grouping_names)}).then(response => {
                    $('#save_groupings').button('reset');

                    this.$notify({
                        type: 'success',
                        text: 'Groupings have been successfully updated.'
                    });

                    this.save_disabled = true;
                    this.fetchServerData();
                });
            },

            validate() {
                this.save_disabled = _.isEqual(this.original_data, this.new_grouping_names);
            }
        }
    }
</script>

<style lang="scss">
    #admin_channel_groupings_page {
        .table-responsive {
            overflow: inherit !important;

            .VueTables__table {
                table-layout: fixed;
                overflow: inherit !important;
            }
        }

        .VueTables__search {
            display: none;
        }

        .VuePagination {
            display: none;
        }

        .v-select {
            width: 25rem;
        }
    }
</style>
